import React, { Component } from 'react';
import { node, any, objectOf, string, func, array } from 'prop-types';
import { withRouter, Route } from 'react-router';
import NProgress from 'nprogress';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { DEFAULT_LOCALE } from '@snapask/common-components/dist/constants/locales';

import asyncMatchRoutes from '@dragonfruit/utils/asyncMatchRoutes';
import { getStore } from '@dragonfruit/store/configureStore';
import { updateUserInfo } from '@dragonfruit/redux/auth';
import { fetchSiteInfo } from '@dragonfruit/redux/siteInfo';
import NotFound from '@dragonfruit/containers/NotFound';
import getPrefetchers from '../../../server/utils/getPrefetchers';
import waitAll from '../../../server/utils/waitAll';

class ReduxAsyncConnect extends Component {
  static propTypes = {
    children: node.isRequired,
    fetchSiteInfo: func.isRequired,
    history: objectOf(any).isRequired,
    location: objectOf(any).isRequired,
    routes: array.isRequired,
    token: string.isRequired,
    updateUserInfo: func.isRequired,
    locale: string,
  };

  static defaultProps = {
    locale: DEFAULT_LOCALE,
  };

  state = {
    previousLocation: null,
  };

  componentDidMount() {
    NProgress.configure({ trickleSpeed: 200 });

    // update user info to latest version by calling api
    const { token, updateUserInfo, fetchSiteInfo } = this.props;
    if (token) updateUserInfo(token);
    fetchSiteInfo();
  }
  async componentWillReceiveProps(nextProps) {
    const { location, routes, locale } = this.props;
    const navigated = nextProps.location !== location;

    if (navigated) {
      // save the location so we can render the old screen
      NProgress.start();
      NProgress.inc();
      this.setState({ previousLocation: location });

      // load data while the old screen remains
      const { components, params } = await asyncMatchRoutes(
        routes,
        nextProps.location.pathname
      );

      // Some routes are in Snapask-Official-Site project. Force reload the
      // page for reverse proxy to route the request to Snapask-Official-Site
      // web server.
      if (components.includes(NotFound)) {
        // Listen after SPA history (caused by history.push) popped out, insert
        // again a full page load targetURL history. Not doing so the browser
        // will not trigger a full page load when user navigate back.
        const handler = () => {
          window.location.reload();
          window.removeEventListener('popstate', handler);
        };
        window.addEventListener('popstate', handler);

        window.location.reload();
        return;
      }

      const prefetchers = getPrefetchers(components, params, { locale });

      // server side preloading data.
      await getStore().runSagas(waitAll(prefetchers)).done;
      this.setState({ previousLocation: null });
      NProgress.done(true);
    }
  }

  render() {
    const { children, location } = this.props;
    const { previousLocation } = this.state;

    // use a controlled <Route> to trick all descendants into
    // rendering the old location
    return (
      <Route location={previousLocation || location} render={() => children} />
    );
  }
}

export default compose(
  withRouter,
  connect(null, {
    updateUserInfo,
    fetchSiteInfo,
  })
)(ReduxAsyncConnect);



// WEBPACK FOOTER //
// ./app/components/ReduxAsyncConnect/ReduxAsyncConnect.jsx